import { getSearchUiState } from '@/redux/modules/search/search.selectors';
import { getUserExcludedHouses } from '@/redux/modules/search/exclusions/searchExclusions.selectors';
import { SearchPageName, SearchQuery, SearchQueryStatus } from '@/types/search/searchQuery';
import { submitSearch } from '@/redux/modules/search/search.actions';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useCallback, useEffect, useState } from 'react';

type Props = {
    searchQuery: SearchQuery;
};

export const useHandleRefetchOnExcludedHouse = ({ searchQuery }: Props) => {
    const userExcludedHouses = useAppSelector(getUserExcludedHouses);
    const [initialHouses, setInitialHouses] = useState<number[]>(userExcludedHouses);
    const dispatch = useAppDispatch();
    const pageName = searchQuery.options.status.includes(SearchQueryStatus.Sold)
        ? SearchPageName.SOLD_SEARCH
        : SearchPageName.SEARCH;
    const { submitted: isLoadingSearchResults } = useAppSelector(getSearchUiState);

    const submitNewSearch = useCallback(() => {
        dispatch(submitSearch({ pageName, searchQuery, useATGSearch: true }));
    }, [dispatch, pageName, searchQuery]);

    // Track initial houses on mount
    useEffect(() => {
        setInitialHouses(userExcludedHouses);
    }, [userExcludedHouses]);

    // Compare current houses with initial houses
    useEffect(() => {
        const initialSet = new Set(initialHouses);
        const currentSet = new Set(userExcludedHouses);
        const hasChanged =
            initialHouses.length !== userExcludedHouses.length ||
            initialHouses.some((id) => !currentSet.has(id)) ||
            userExcludedHouses.some((id) => !initialSet.has(id));

        if (hasChanged && !isLoadingSearchResults) {
            submitNewSearch();
        }
    }, [initialHouses, isLoadingSearchResults, submitNewSearch, userExcludedHouses]);
};
